import { useInfiniteQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type {
  EmailMailboxFilter,
  EmailPeriodFilter,
  EmailToolbarTab,
} from "../_constants/email-toolbar.const";
import type { GmailMessageListItem, GmailMessagesMeta } from "../_types/gmail.types";

type PageResult = {
  items: GmailMessageListItem[];
  nextPageToken: string | null;
};

export const useEmailsQuery = (
  tab: EmailToolbarTab,
  period: EmailPeriodFilter,
  mailbox: EmailMailboxFilter,
) => {
  return useInfiniteQuery({
    queryKey: ["gmail-messages", tab, period, mailbox],
    queryFn: async ({ pageParam }: { pageParam: string | undefined }): Promise<PageResult> => {
      const response = await axiosInstance.get<
        ApiResponse<GmailMessageListItem[], GmailMessagesMeta>
      >("/v2/inbox/emails/messages", {
        params: {
          maxResults: 20,
          tab,
          period,
          mailbox,
          ...(pageParam ? { pageToken: pageParam } : {}),
        },
      });

      return {
        items: response.data.data ?? [],
        nextPageToken: response.data.meta?.nextPageToken ?? null,
      };
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextPageToken ?? undefined,
  });
};
